function layoutPdpQtyBuyStack(root) {
  if (!root || root.closest('quick-add-modal')) return;

  const productForm = root.querySelector('product-form');
  const qty = root.querySelector('.product-form__quantity');
  if (!productForm || productForm.dataset.pdpBuyLayout === '1') return;

  const form = productForm.querySelector('form');
  const buttons = form && form.querySelector('.product-form__buttons');
  if (!form || !buttons) return;

  const submit =
    buttons.querySelector('.product-form__submit') ||
    buttons.querySelector('button[type="submit"][name="add"]');
  if (!submit) return;

  const actions = buttons.querySelector('.pdp-product-actions');
  let payment = buttons.querySelector('.shopify-payment-button');
  if (!payment) {
    payment = buttons.querySelector('shopify-accelerated-checkout');
  }
  if (payment === submit) payment = null;
  const preservedChildren = Array.from(buttons.children).filter(
    (el) => el !== submit && el !== payment && el !== actions
  );

  const stack = document.createElement('div');
  stack.className = 'pdp-qty-buy-stack';

  const mainRow = document.createElement('div');
  mainRow.className = 'pdp-buy-main-row';

  const submitWrap = document.createElement('div');
  submitWrap.className = 'pdp-submit-wrap';

  if (qty) mainRow.appendChild(qty);
  submitWrap.appendChild(submit);
  mainRow.appendChild(submitWrap);
  if (actions) mainRow.appendChild(actions);
  stack.appendChild(mainRow);

  if (payment) {
    const paymentRow = document.createElement('div');
    paymentRow.className = 'pdp-payment-row';
    paymentRow.appendChild(payment);
    stack.appendChild(paymentRow);
  }

  while (buttons.firstChild) {
    buttons.removeChild(buttons.firstChild);
  }
  preservedChildren.forEach((child) => buttons.appendChild(child));
  buttons.appendChild(stack);

  productForm.closest('.product-form__buy-buttons')?.classList.remove('product-form__buy-buttons--loading');
  productForm.dataset.pdpBuyLayout = '1';
  normalizePdpSellingPlanWidgets(root);
}

function normalizePdpSellingPlanWidgets(root) {
  if (!root || root.closest('quick-add-modal')) return;

  const buttons = root.querySelector('product-form .product-form__buttons');
  const stack = buttons?.querySelector('.pdp-qty-buy-stack');
  if (!buttons || !stack) return;

  const widgetRoots = new Set(
    Array.from(
      buttons.querySelectorAll('.appstle_sub_widget, [id^="appstle_subscription_widget"], .appstle_subscription_widget')
    ).map((widget) => widget.closest('.appstle_sub_widget') || widget)
  );

  widgetRoots.forEach((widgetRoot) => {
    if (!widgetRoot || widgetRoot === stack) return;

    if (widgetRoot.parentElement !== buttons) {
      buttons.insertBefore(widgetRoot, stack);
      return;
    }

    if (widgetRoot.compareDocumentPosition(stack) & Node.DOCUMENT_POSITION_PRECEDING) {
      buttons.insertBefore(widgetRoot, stack);
    }
  });
}

const pdpBundleThumbnailCache = new Map();

function getPdpBundleProductTitle(optionGroup) {
  return (optionGroup?.dataset.bundleProductTitle || '').trim();
}

function getPdpBundleThumbnailUrl(product) {
  const image = product?.image;
  if (!image) return '';

  if (typeof image === 'string') return image;
  return image.url || image.src || '';
}

function getPdpBundleSelectedValue(optionGroup) {
  return optionGroup.querySelector('input[type="radio"]:checked')?.value || optionGroup.querySelector('select')?.value || '';
}

function getPdpBundleVariantImageUrl(product, selectedValue) {
  if (!product || !selectedValue) return '';

  const selectedValueNormalized = selectedValue.trim().toLowerCase();
  const variant = product.variants?.find((item) =>
    [item.title, item.option1, item.option2, item.option3].some(
      (value) => typeof value === 'string' && value.trim().toLowerCase() === selectedValueNormalized
    )
  );

  return variant?.featured_image?.src || getPdpBundleThumbnailUrl(product);
}

function updatePdpBundleMainMedia(optionGroup, imageUrl, title) {
  const productInfo = optionGroup.closest('product-info');
  const productRoot = productInfo?.closest('.product') || productInfo?.parentElement;
  const mediaGallery = productRoot?.querySelector('media-gallery') || document.querySelector('media-gallery');
  const activeMedia = mediaGallery?.querySelector('.product__media-item.is-active');
  const mediaItem = activeMedia || mediaGallery?.querySelector('.product__media-item');
  const image = mediaItem?.querySelector('img');
  if (!image || !imageUrl) return;

  image.src = imageUrl;
  image.srcset = imageUrl;
  image.alt = title || image.alt || '';
  mediaItem?.setAttribute('data-bundle-media-image', imageUrl);
}

function renderPdpBundleThumbnail(optionGroup, product) {
  const thumbnail = optionGroup.querySelector('[data-bundle-product-thumbnail]');
  const selectedValue = getPdpBundleSelectedValue(optionGroup);
  const imageUrl = getPdpBundleVariantImageUrl(product, selectedValue) || getPdpBundleThumbnailUrl(product);
  if (!thumbnail || !imageUrl) return;

  const title = product?.title || getPdpBundleProductTitle(optionGroup);
  const image = document.createElement('img');
  image.src = imageUrl;
  image.alt = title || '';
  image.loading = 'lazy';
  image.width = 64;
  image.height = 64;
  thumbnail.replaceChildren(image);
  thumbnail.hidden = false;
  updatePdpBundleMainMedia(optionGroup, imageUrl, title);
}

function initPdpBundleProductThumbnails(root) {
  if (!root) return;

  root.querySelectorAll('[data-bundle-product-title]').forEach((optionGroup) => {
    const title = getPdpBundleProductTitle(optionGroup);
    if (!title) return;

    if (pdpBundleThumbnailCache.has(title)) {
      renderPdpBundleThumbnail(optionGroup, pdpBundleThumbnailCache.get(title));
      return;
    }

    if (optionGroup.dataset.bundleThumbnailLoading === 'true') return;
    optionGroup.dataset.bundleThumbnailLoading = 'true';

    const suggestUrl = `/search/suggest.json?q=${encodeURIComponent(title)}&resources[type]=product&resources[limit]=1`;
    fetch(suggestUrl)
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        const product = data?.resources?.results?.products?.[0];
        if (!product?.handle) return product || null;

        return fetch(`/products/${product.handle}.js`)
          .then((response) => (response.ok ? response.json() : product))
          .catch(() => product);
      })
      .then((product) => {
        optionGroup.dataset.bundleThumbnailLoading = 'false';
        pdpBundleThumbnailCache.set(title, product || null);
        renderPdpBundleThumbnail(optionGroup, product);
      })
      .catch(() => {
        optionGroup.dataset.bundleThumbnailLoading = 'false';
        pdpBundleThumbnailCache.set(title, null);
      });
  });
}

function formatPdpStickyMoney(cents, currency) {
  const amount = Number(cents || 0) / 100;
  const locale = document.documentElement.lang || undefined;

  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency || 'USD',
      currencyDisplay: 'narrowSymbol',
    }).format(amount);
  } catch (error) {
    return `$${amount.toFixed(2)}`;
  }
}

function getPdpStickyVariant(root, variants, variantId) {
  const id = String(variantId || root.querySelector('.product-variant-id')?.value || '');
  return variants.find((variant) => String(variant.id) === id) || variants[0];
}

function initPdpStickyCart(root) {
  if (!root || root.closest('quick-add-modal')) return;

  const stickyCart = root.querySelector('[data-pdp-sticky-cart]');
  if (!stickyCart || stickyCart.dataset.initialized === 'true') return;

  const variantsScript = stickyCart.querySelector('[data-pdp-sticky-variants]');
  let variants = [];
  try {
    variants = JSON.parse(variantsScript?.textContent || '[]');
  } catch (error) {
    console.error('Error reading sticky cart variants:', error);
  }
  if (!variants.length) return;

  stickyCart.dataset.initialized = 'true';

  const currency = stickyCart.dataset.currency || 'USD';
  const variantSelect = stickyCart.querySelector('[data-pdp-sticky-variant]');
  const quantityInput = stickyCart.querySelector('[data-pdp-sticky-qty-input]');
  const minusButton = stickyCart.querySelector('.pdp-sticky-cart__qty-button[name="minus"]');
  const plusButton = stickyCart.querySelector('.pdp-sticky-cart__qty-button[name="plus"]');
  const submitButton = stickyCart.querySelector('[data-pdp-sticky-submit]');
  const submitText = stickyCart.querySelector('[data-pdp-sticky-submit-text]');
  const price = stickyCart.querySelector('[data-pdp-sticky-price]');
  const image = stickyCart.querySelector('[data-pdp-sticky-image]');

  const getMainQuantityInput = () =>
    root.querySelector(`#Quantity-${CSS.escape(root.dataset.section)}`) ||
    root.querySelector('.product-form__quantity .quantity__input');
  const getMainSubmitButton = () =>
    root.querySelector(`#ProductSubmitButton-${CSS.escape(root.dataset.section)}`) ||
    root.querySelector('product-form [type="submit"][name="add"]');
  const getTriggerTarget = () => {
    const realInfoWrapper = root.querySelector('.product__info-wrapper:not(.sticksy-dummy-node)');
    const realStack = Array.from(root.querySelectorAll('.pdp-qty-buy-stack')).find(
      (item) => !item.closest('.sticksy-dummy-node')
    );
    return (
      realInfoWrapper?.querySelector('.pdp-qty-buy-stack') ||
      realInfoWrapper?.querySelector('.product-form__buttons') ||
      realInfoWrapper?.querySelector('product-form') ||
      realStack ||
      root.querySelector('.product-form__buttons') ||
      root.querySelector('product-form')
    );
  };

  let isSyncingQuantity = false;

  const clampQuantity = (value) => {
    const min = quantityInput.min ? Number(quantityInput.min) : 1;
    const max = quantityInput.max ? Number(quantityInput.max) : null;
    const parsedValue = Number(value);
    let nextValue = Number.isFinite(parsedValue) ? parsedValue : min;
    nextValue = Math.max(nextValue, min);
    if (max !== null) nextValue = Math.min(nextValue, max);
    return nextValue;
  };

  const syncQuantityButtons = () => {
    const value = Number(quantityInput.value);
    const min = quantityInput.min ? Number(quantityInput.min) : 1;
    const max = quantityInput.max ? Number(quantityInput.max) : null;
    if (minusButton) minusButton.disabled = value <= min;
    if (plusButton) plusButton.disabled = max !== null && value >= max;
  };

  const syncStickyQuantityFromMain = () => {
    const mainQuantityInput = getMainQuantityInput();
    if (!mainQuantityInput || !quantityInput || isSyncingQuantity) return;

    ['min', 'max', 'step'].forEach((attribute) => {
      const value = mainQuantityInput.getAttribute(attribute);
      if (value !== null) {
        quantityInput.setAttribute(attribute, value);
      } else {
        quantityInput.removeAttribute(attribute);
      }
    });

    quantityInput.value = mainQuantityInput.value || quantityInput.min || '1';
    syncQuantityButtons();
  };

  const syncMainQuantityFromSticky = () => {
    const mainQuantityInput = getMainQuantityInput();
    if (!mainQuantityInput || !quantityInput) return;

    isSyncingQuantity = true;
    quantityInput.value = clampQuantity(quantityInput.value);
    mainQuantityInput.value = quantityInput.value;
    mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    isSyncingQuantity = false;
    syncQuantityButtons();
  };

  const updateSubmitState = () => {
    const mainSubmitButton = getMainSubmitButton();
    if (!mainSubmitButton || !submitButton) return;

    const isDisabled =
      mainSubmitButton.hasAttribute('disabled') || mainSubmitButton.getAttribute('aria-disabled') === 'true';
    const isLoading = mainSubmitButton.classList.contains('loading');
    const stickySpinner = submitButton.querySelector('.loading__spinner');
    submitButton.disabled = isDisabled;
    submitButton.classList.toggle('loading', isLoading);
    if (stickySpinner) stickySpinner.classList.toggle('hidden', !isLoading);

    const mainSubmitText = mainSubmitButton.querySelector('span');
    if (submitText && mainSubmitText) submitText.textContent = mainSubmitText.textContent.trim();
  };

  const updateVariantDisplay = (variant) => {
    if (!variant) return;

    if (variantSelect) variantSelect.value = String(variant.id);

    if (price) {
      const regularPrice = formatPdpStickyMoney(variant.price, currency);
      const comparePrice =
        variant.compare_at_price && variant.compare_at_price > variant.price
          ? `<s>${formatPdpStickyMoney(variant.compare_at_price, currency)}</s>`
          : '';
      price.innerHTML = `${comparePrice}<span>${regularPrice}</span>`;
    }

    const variantImage = variant.featured_image?.src || variant.featured_media?.preview_image?.src;
    if (image && variantImage) image.src = variantImage;

    updateSubmitState();
    syncStickyQuantityFromMain();
  };

  const selectMainVariant = (variant) => {
    const variantSelectors = root.querySelector('variant-selects');
    if (!variantSelectors || !variant?.options?.length) {
      window.location.href = `${root.dataset.url}?variant=${variant.id}`;
      return;
    }

    const optionContainers = Array.from(variantSelectors.querySelectorAll('.product-form__input'));
    const changedInputs = variant.options
      .map((optionValue, index) => {
        const container = optionContainers[index];
        if (!container) return null;

        const select = container.querySelector('select');
        if (select) {
          Array.from(select.options).forEach((option) => option.removeAttribute('selected'));
          const option = Array.from(select.options).find((item) => item.value === optionValue);
          if (!option) return null;
          select.value = optionValue;
          option.setAttribute('selected', 'selected');
          variantSelectors.updateSelectionMetadata?.({ target: select });
          return select;
        }

        const input = Array.from(container.querySelectorAll('input[type="radio"], input[type="checkbox"]')).find(
          (item) => item.value === optionValue
        );
        if (!input) return null;
        input.checked = true;
        variantSelectors.updateSelectionMetadata?.({ target: input });
        return input;
      })
      .filter(Boolean);

    const eventTarget = changedInputs[changedInputs.length - 1];
    if (eventTarget) {
      eventTarget.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      window.location.href = `${root.dataset.url}?variant=${variant.id}`;
    }
  };

  const updateVisibility = () => {
    const target = getTriggerTarget();
    if (!target) return;

    const rect = target.getBoundingClientRect();
    const shouldShow = rect.bottom <= 0;
    stickyCart.classList.toggle('is-visible', shouldShow);
    stickyCart.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
  };

  variantSelect?.addEventListener('change', () => {
    const variant = variants.find((item) => String(item.id) === variantSelect.value);
    if (!variant) return;
    updateVariantDisplay(variant);
    selectMainVariant(variant);
  });

  quantityInput?.addEventListener('change', syncMainQuantityFromSticky);
  quantityInput?.addEventListener('input', syncQuantityButtons);
  minusButton?.addEventListener('click', () => {
    quantityInput.stepDown();
    syncMainQuantityFromSticky();
  });
  plusButton?.addEventListener('click', () => {
    quantityInput.stepUp();
    syncMainQuantityFromSticky();
  });
  submitButton?.addEventListener('click', () => {
    syncMainQuantityFromSticky();
    submitButton.classList.add('loading');
    submitButton.querySelector('.loading__spinner')?.classList.remove('hidden');
    getMainSubmitButton()?.click();
  });

  getMainQuantityInput()?.addEventListener('change', syncStickyQuantityFromMain);

  const submitObserver = new MutationObserver(updateSubmitState);
  const observeSubmitButton = () => {
    const mainSubmitButton = getMainSubmitButton();
    if (mainSubmitButton) {
      submitObserver.observe(mainSubmitButton, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class'],
      });
    }
  };
  observeSubmitButton();

  window.addEventListener('scroll', updateVisibility, { passive: true });
  window.addEventListener('resize', updateVisibility);
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    if (event?.data?.sectionId !== root.sectionId) return;
    updateVariantDisplay(event.data.variant);
  });
  subscribe(PUB_SUB_EVENTS.quantityUpdate, syncStickyQuantityFromMain);

  updateVariantDisplay(getPdpStickyVariant(root, variants));
  updateVisibility();
}

function productActionItemMatches(item, productId, productHandle) {
  if (item && typeof item === 'object') {
    return String(item.id || '').trim() === productId || String(item.handle || '').trim() === productHandle;
  }

  const itemStr = String(item).trim();
  return itemStr === productId || itemStr === productHandle;
}

function setPdpProductActionState(button, isActive) {
  const label = isActive ? button.dataset.removeLabel : button.dataset.addLabel;
  button.classList.toggle('is-active', isActive);
  button.setAttribute('aria-label', label);
  button.dataset.tooltip = label;
}

function getStoredProductActions(storageKey) {
  try {
    const items = JSON.parse(localStorage.getItem(storageKey) || '[]');
    return Array.isArray(items) ? items : [];
  } catch (error) {
    console.error(`Error reading ${storageKey}:`, error);
    return [];
  }
}

function getPdpCompareProductFromButton(button) {
  return {
    id: button.dataset.productId || '',
    handle: button.dataset.productHandle || '',
    title: button.dataset.productTitle || '',
    url: button.dataset.productUrl || '#',
    image: button.dataset.productImage || '',
  };
}

function escapePdpCompareHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function normalizePdpCompareItems(items) {
  const seen = new Set();

  return items
    .map((item) => {
      if (item && typeof item === 'object') {
        return {
          id: String(item.id || '').trim(),
          handle: String(item.handle || '').trim(),
          title: String(item.title || '').trim(),
          url: String(item.url || '#').trim() || '#',
          image: String(item.image || '').trim(),
        };
      }

      return {
        id: String(item || '').trim(),
        handle: '',
        title: '',
        url: '#',
        image: '',
      };
    })
    .filter((item) => {
      const key = item.id || item.handle;
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
}

function getPdpComparePageUrl() {
  return window.manasComparePageUrl || '/pages/compare';
}

function syncPdpCompareDrawerLink(drawer) {
  const compareLink = drawer ? drawer.querySelector('.pdp-compare-drawer__compare-button') : null;
  if (compareLink) compareLink.href = getPdpComparePageUrl();
  return compareLink;
}

function ensurePdpCompareDrawer() {
  let drawer = document.getElementById('PdpCompareDrawer');
  if (drawer) {
    syncPdpCompareDrawerLink(drawer);
    return drawer;
  }

  drawer = document.createElement('aside');
  drawer.id = 'PdpCompareDrawer';
  drawer.className = 'pdp-compare-drawer';
  drawer.setAttribute('aria-label', 'Compare products');
  drawer.innerHTML = `
    <div class="pdp-compare-drawer__inner">
      <button type="button" class="pdp-compare-drawer__close" data-compare-close aria-label="Close compare products">
        <svg viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M1 1l12 12M13 1L1 13" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>
      </button>
      <h2 class="pdp-compare-drawer__title">Compare Products</h2>
      <div class="pdp-compare-drawer__carousel">
        <button type="button" class="pdp-compare-drawer__arrow pdp-compare-drawer__arrow--prev" data-compare-scroll="prev" aria-label="Previous compare products">
          <svg class="icon icon-caret" viewBox="0 0 10 6" aria-hidden="true" focusable="false"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path></svg>
        </button>
        <div class="pdp-compare-drawer__items" data-compare-items></div>
        <button type="button" class="pdp-compare-drawer__arrow pdp-compare-drawer__arrow--next" data-compare-scroll="next" aria-label="Next compare products">
          <svg class="icon icon-caret" viewBox="0 0 10 6" aria-hidden="true" focusable="false"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path></svg>
        </button>
      </div>
      <div class="pdp-compare-drawer__actions">
        <a href="${getPdpComparePageUrl()}" class="button button--primary pdp-compare-drawer__compare-button"><span>Compare</span></a>
        <button type="button" class="pdp-compare-drawer__clear" data-compare-clear>Clear All</button>
      </div>
    </div>
  `;
  document.body.appendChild(drawer);

  const compareLink = syncPdpCompareDrawerLink(drawer);
  if (window.ManasTheme) {
    window.ManasTheme.applyPrimaryButtonModifier(compareLink);
    window.ManasTheme.ensureButtonLabelSpan(compareLink);
  }

  drawer.addEventListener('click', function (event) {
    const removeButton = event.target.closest('[data-compare-remove]');
    const closeButton = event.target.closest('[data-compare-close]');
    const clearButton = event.target.closest('[data-compare-clear]');
    const scrollButton = event.target.closest('[data-compare-scroll]');

    if (closeButton) {
      drawer.classList.remove('is-open');
      return;
    }

    if (clearButton) {
      localStorage.setItem('manas_compare', JSON.stringify([]));
      renderPdpCompareDrawer([], false);
      window.dispatchEvent(new CustomEvent('compare:updated', { detail: { items: [] } }));
      return;
    }

    if (scrollButton) {
      const itemsContainer = drawer.querySelector('[data-compare-items]');
      const direction = scrollButton.dataset.compareScroll === 'prev' ? -1 : 1;
      itemsContainer.scrollBy({
        left: direction * Math.max(itemsContainer.clientWidth * 0.8, 180),
        behavior: 'smooth',
      });
      return;
    }

    if (removeButton) {
      const productId = removeButton.dataset.productId;
      const productHandle = removeButton.dataset.productHandle;
      const items = getStoredProductActions('manas_compare').filter(
        (item) => !productActionItemMatches(item, productId, productHandle)
      );
      localStorage.setItem('manas_compare', JSON.stringify(items));
      renderPdpCompareDrawer(items, items.length > 0);
      window.dispatchEvent(new CustomEvent('compare:updated', { detail: { items } }));
    }
  });

  return drawer;
}

function renderPdpCompareDrawer(items = getStoredProductActions('manas_compare'), shouldOpen = false) {
  const drawer = ensurePdpCompareDrawer();
  const normalizedItems = normalizePdpCompareItems(items);
  const itemsContainer = drawer.querySelector('[data-compare-items]');

  itemsContainer.innerHTML = normalizedItems
    .map((item) => {
      const title = escapePdpCompareHtml(item.title || item.handle || item.id);
      const image = item.image
        ? `<img src="${escapePdpCompareHtml(item.image)}" alt="${title}" loading="lazy">`
        : `<span class="pdp-compare-drawer__placeholder" aria-hidden="true"></span>`;

      return `
        <div class="pdp-compare-drawer__item">
          <button
            type="button"
            class="pdp-compare-drawer__remove"
            data-compare-remove
            data-product-id="${escapePdpCompareHtml(item.id)}"
            data-product-handle="${escapePdpCompareHtml(item.handle)}"
            aria-label="Remove ${title} from compare"
          ><svg viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M1 1l12 12M13 1L1 13" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg></button>
          <a href="${escapePdpCompareHtml(item.url)}" class="pdp-compare-drawer__product">
            ${image}
            <span class="pdp-compare-drawer__product-title">${title}</span>
          </a>
        </div>
      `;
    })
    .join('');

  drawer.classList.toggle('is-empty', normalizedItems.length === 0);
  drawer.classList.toggle('has-carousel', normalizedItems.length > 1);
  if (shouldOpen && normalizedItems.length > 0) {
    drawer.classList.add('is-open');
    itemsContainer.scrollTo({ left: 0, behavior: 'auto' });
  }
  if (normalizedItems.length === 0) {
    drawer.classList.remove('is-open');
  }
}

function initPdpProductActions(root = document) {
  try {
    const wishlist = getStoredProductActions('manas_wishlist');
    root.querySelectorAll('.product-form__wishlist-button').forEach((button) => {
      const productId = button.dataset.productId;
      const productHandle = button.dataset.productHandle;
      const isInWishlist = wishlist.some((item) => productActionItemMatches(item, productId, productHandle));
      setPdpProductActionState(button, isInWishlist);
    });

    const compare = getStoredProductActions('manas_compare');
    root.querySelectorAll('.product-form__compare-button').forEach((button) => {
      const productId = button.dataset.productId;
      const productHandle = button.dataset.productHandle;
      const isCompared = compare.some((item) => productActionItemMatches(item, productId, productHandle));
      setPdpProductActionState(button, isCompared);
    });
  } catch (error) {
    console.error('Error initializing product action buttons:', error);
  }
}

function bindPdpProductActions() {
  if (window.pdpProductActionsInitialized) return;
  window.pdpProductActionsInitialized = true;

  document.addEventListener('click', function (event) {
    const wishlistButton = event.target.closest('.product-form__wishlist-button');
    const compareButton = event.target.closest('.product-form__compare-button');
    const button = wishlistButton || compareButton;
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const productId = button.dataset.productId;
    const productHandle = button.dataset.productHandle;
    if (!productId && !productHandle) return;

    const storageKey = wishlistButton ? 'manas_wishlist' : 'manas_compare';
    const eventName = wishlistButton ? 'wishlist:updated' : 'compare:updated';

    try {
      let items = getStoredProductActions(storageKey);
      const isActive = items.some((item) => productActionItemMatches(item, productId, productHandle));

      if (isActive) {
        items = items.filter((item) => !productActionItemMatches(item, productId, productHandle));
      } else if (compareButton) {
        items.unshift(getPdpCompareProductFromButton(button));
      } else {
        items.push({
          id: productId || '',
          handle: productHandle || '',
        });
      }

      localStorage.setItem(storageKey, JSON.stringify(items));
      setPdpProductActionState(button, !isActive);
      if (compareButton) renderPdpCompareDrawer(items, !isActive);
      window.dispatchEvent(new CustomEvent(eventName, { detail: { items } }));
    } catch (error) {
      console.error('Error updating product action button:', error);
    }
  });

  window.addEventListener('wishlist:updated', function () {
    initPdpProductActions();
  });
  window.addEventListener('compare:updated', function () {
    initPdpProductActions();
    renderPdpCompareDrawer(getStoredProductActions('manas_compare'));
  });
}

if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        bindPdpProductActions();
        initPdpProductActions();
        renderPdpCompareDrawer(getStoredProductActions('manas_compare'));
        layoutPdpQtyBuyStack(this);
        normalizePdpSellingPlanWidgets(this);
        initPdpBundleProductThumbnails(this);
        initPdpStickyCart(this);
        setTimeout(() => layoutPdpQtyBuyStack(this), 0);
        setTimeout(() => normalizePdpSellingPlanWidgets(this), 500);
        setTimeout(() => normalizePdpSellingPlanWidgets(this), 2000);
        setTimeout(() => normalizePdpSellingPlanWidgets(this), 4000);
        setTimeout(() => initPdpBundleProductThumbnails(this), 0);
        setTimeout(() => initPdpStickyCart(this), 0);
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          const productInfoNode = newNode?.matches?.('product-info')
            ? newNode
            : newNode?.querySelector?.('product-info');
          if (productInfoNode) {
            initPdpProductActions(productInfoNode);
            layoutPdpQtyBuyStack(productInfoNode);
            normalizePdpSellingPlanWidgets(productInfoNode);
            initPdpBundleProductThumbnails(productInfoNode);
            initPdpStickyCart(productInfoNode);
          }
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();
        this.setMediaLoadingState(true);

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          })
          .finally(() => {
            // Fallback guard to avoid leaving gallery in loading state on errors/unavailable variant.
            this.setMediaLoadingState(false);
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          initPdpBundleProductThumbnails(this);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) {
          this.setMediaLoadingState(false);
          return;
        }

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );
        this.waitForActiveMediaReady().finally(() => {
          this.setMediaLoadingState(false);
        });

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setMediaLoadingState(isLoading) {
        const mediaGallery = this.querySelector('media-gallery');
        const mediaWrapper = this.querySelector('.product__media-wrapper');
        if (mediaGallery) mediaGallery.classList.toggle('is-media-loading', isLoading);
        if (mediaWrapper) mediaWrapper.classList.toggle('is-media-loading', isLoading);
      }

      waitForActiveMediaReady() {
        const activeMedia = this.querySelector('media-gallery [data-media-id].is-active');
        if (!activeMedia) return Promise.resolve();

        const activeImage = activeMedia.querySelector('img');
        if (!activeImage) return Promise.resolve();

        if (activeImage.complete && activeImage.naturalWidth > 0) return Promise.resolve();

        return new Promise((resolve) => {
          const done = () => resolve();
          activeImage.addEventListener('load', done, { once: true });
          activeImage.addEventListener('error', done, { once: true });
        });
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
            if (selector === '.quantity__label') {
              const updatedAriaLabelledBy = updated.getAttribute('aria-labelledby');
              if (updatedAriaLabelledBy) {
                current.setAttribute('aria-labelledby', updatedAriaLabelledBy);
                // Update the referenced visually hidden element
                const labelId = updatedAriaLabelledBy;
                const currentHiddenLabel = document.getElementById(labelId);
                const updatedHiddenLabel = html.getElementById(labelId);
                if (currentHiddenLabel && updatedHiddenLabel) {
                  currentHiddenLabel.textContent = updatedHiddenLabel.textContent;
                }
              }
            }
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
